export default "__VITE_ASSET__yNjeLz8F__"